"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentTypeUsesKeySystemRootKeyEncryption = void 0;
const domain_core_1 = require("@standardnotes/domain-core");
function ContentTypeUsesKeySystemRootKeyEncryption(contentType) {
    return contentType === domain_core_1.ContentType.TYPES.KeySystemItemsKey;
}
exports.ContentTypeUsesKeySystemRootKeyEncryption = ContentTypeUsesKeySystemRootKeyEncryption;
